import React from 'react';
import PropTypes from 'prop-types';
import moment from 'moment';
import { connect } from 'react-redux';
import _ from 'lodash';
import { DateField } from './schedule_utils';
import { getDateValue, backToDate } from '../../utils/date';
import Select from 'react-select';
import {fetch_lkp_DelaysGains, fetch_lkp_DelayPhaseOfOccurrence, fetch_lkp_DelayCategory, fetch_lkp_DelaySubcategory, fetch_lkp_DelayAttributedTos} from '../../actions/additional_actions';

const FMT = 'MM/DD/YYYY';

class DelayLogForm extends React.Component {
  constructor (props) {
    super(props);

    this.state = {
      ...this.getInitialState(props.log)
    }
    
    this.handleSubmit = this.handleSubmit.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.handleDelaysGainsChange = this.handleDelaysGainsChange.bind(this);
    this.handleAttributedToChange = this.handleAttributedToChange.bind(this);
    this.handlePhaseOfOccurrenceChange = this.handlePhaseOfOccurrenceChange.bind(this);
    this.handleCategoryChange = this.handleCategoryChange.bind(this);
    this.handleSubcategoryChange = this.handleSubcategoryChange.bind(this);
    this.handleOverallScheduleImpactChange = this.handleOverallScheduleImpactChange.bind(this);
  }

  componentDidMount() {
    this.props.fetch_lkp_DelayAttributedTos();
    this.props.fetch_lkp_DelayCategory();
    this.props.fetch_lkp_DelaySubcategory();
    this.props.fetch_lkp_DelaysGains();
    this.props.fetch_lkp_DelayPhaseOfOccurrence();

    let disableSubcategory = true;
    if (this.state.subcategoryId) {
        disableSubcategory = false;
    }
    
    this.setState({ disableSubcategory });
  }

  getInitialState ({
    location = '', 
    startDate = '',
    endDate = '',
    cause = '', 
    attributedTo = '', 
    delaysGainsId = '',
    attributedToId = '',
    phaseOfOccurrenceId = '',
    categoryId = '',
    subcategoryId = '',
    overallScheduleImpact = '',
    disableSubcategory = true
  }) {
    return {
      location,
      startDate: getDateValue(startDate),
      endDate: getDateValue(endDate),
      cause, 
      attributedTo,
      delaysGainsId,
      attributedToId,
      phaseOfOccurrenceId,
      categoryId,
      subcategoryId,
      overallScheduleImpact,
      disableSubcategory
    }
  }

  getDelaysGainsOptions() {
    return this.props.delaysGains.map(delayGains => {
      return {
        label: delayGains.name,
        value: delayGains.delaysGainsId
      }
    });
  }

  handleDelaysGainsChange(option) {
    const delaysGainsId = option ? option.value : '';
    this.setState({ delaysGainsId });
  }

  getAttributedToOptions() {
    return this.props.delayAttributedTos.map(attributedTo => {
      return {
        label: attributedTo.name,
        value: attributedTo.attributedToId
      }
    });
  }

  handleAttributedToChange(option) {
    const attributedToId = option ? option.value : '';
    this.setState({ attributedToId });
  }
  
  getPhaseOfOccurrenceOptions() {
    return this.props.delayPhasesOfOccurence.map(phaseOfOccurence => {
      return {
        label: phaseOfOccurence.phaseName,
        value: phaseOfOccurence.phaseOfOccurrenceId
      }
    });
  }
  
  handlePhaseOfOccurrenceChange(option) {
    const phaseOfOccurrenceId = option ? option.value : '';
    this.setState({ phaseOfOccurrenceId });
  }

  getCategoryOptions() {
    return this.props.delayCategories.map(category => {
      return {
        label: category.categoryName,
        value: category.categoryId
      }
    });
  }
  
  handleCategoryChange(option) {
    const categoryId = option ? option.value : '';
    let disableSubcategory = true;
    let subcategoryId = ''

    if (categoryId) {
        disableSubcategory = false;
    }
    
    this.setState({ categoryId, disableSubcategory, subcategoryId });
  }

  getOptionsForSubPhase(subPhases) {
    const values = subPhases;
    if (values.length > 0) {
        return values[0].subPhases.map(value => {
            return { label: value, value }
        });
    }
}
  getSubcategoryOptions(subcategories) {
    return subcategories.map(subcategory => {
      return {
        label: subcategory.subcategoryName,
        value: subcategory.subcategoryId
      }
    });
  }

  handleSubcategoryChange(option) {
    const subcategoryId = option ? option.value : '';
    this.setState({ subcategoryId });
  }

  handleOverallScheduleImpactChange(e) {
    var overallScheduleImpact = parseInt(e.target.value);
    
    if (isNaN(overallScheduleImpact)) {
        overallScheduleImpact = '';
    }

    this.setState({ overallScheduleImpact });
  }

  handleDateChange (name) {
    return (date) => {
      this.setState({
        [name]: date,
      });
    }
  }

  handleChange(field) {
    return (e) => {
      this.setState({ [field]: e.target.value });
    }
  }

  handleSubmit (e) {
    e.preventDefault();
    const requiredFields = 'location,cause,delaysGainsId,overallScheduleImpact,attributedToId,categoryId,subcategoryId,phaseOfOccurrenceId'.split(',');
    const requiredValues = _.pick(this.state, requiredFields)
    
    const otherValues = {};
    const startDate = this.state.startDate;
    const endDate = this.state.endDate;
    
    otherValues.attributedTo = this.state.attributedTo;
    otherValues.totalDelayDays = this.getDelay({endDate, startDate});
    otherValues.startDate = backToDate(startDate);
    otherValues.endDate = backToDate(endDate);

    if ( _.every(requiredValues) ) {
      this.props.onSubmit({
        ...this.props.log,
        ...requiredValues,
        ...otherValues
      });
    }
  }

  getDelay ({ endDate, startDate }) {
    if (!endDate) return 0;
    const oldValue = moment(startDate, FMT);
    const newValue = moment(endDate, FMT);
    return newValue.diff(oldValue, 'days');
  }

  render () {
    
    const { startDate, endDate, cause, location, delaysGainsId, overallScheduleImpact,
        attributedToId, categoryId, subcategoryId, phaseOfOccurrenceId } = this.state;

    const delay = this.getDelay({endDate, startDate});
    
    const canSubmit = _.every([cause, location, delaysGainsId, overallScheduleImpact,
        attributedToId, categoryId, subcategoryId, phaseOfOccurrenceId]);

    return (
        
      <form className="modal-form" onSubmit={this.handleSubmit}>
        
        <div className="delay-log-details three-cols">
            <div className="control">
                <label>Project Id</label>
                <input type="text" name="projectId" className="delay-log-control"
                    value={this.props.projectId}
                    disabled
                />
            </div>
            <div className="control required">
                <label>Location</label>
                <input type="text" name="location" className="delay-log-control"
                    value={this.state.location}
                    onChange={this.handleChange('location')}
                />
            </div>
            <div className="control required">
                <label>Delay/Gain</label>
                <Select name="delaysGains"
                    value={this.state.delaysGainsId}
                    options={this.getDelaysGainsOptions()}
                    onChange={this.handleDelaysGainsChange}
                />
            </div>
        </div>
        
        <div className="delay-log-details three-cols">
            <div className="control required">
                <label>Overall Schedule Impact (CCDs)</label>
                <input type="number" name="ccds" className="delay-log-control"
                    value={this.state.overallScheduleImpact}
                    onChange={this.handleOverallScheduleImpactChange}
                />
            </div>
            <div className="control required">
                <label>Attributed To</label>
                <Select name="attributedTo" className="delay-log-control"
                    value={this.state.attributedToId}
                    options={this.getAttributedToOptions()}
                    onChange={this.handleAttributedToChange}
                />
            </div>
            { (this.props.log.id > 0 && this.props.log.attributedTo && this.props.log.attributedTo.length > 0 ) ? <div className="control">
                <label>Historical Attributed To</label>
                <input type="text" name="historicalAttributedTo"
                    value={this.state.attributedTo}
                    onChange={this.handleChange('attributedTo')}
                />
            </div> : null }   
        </div>
        
        <div className="delay-log-details three-cols">
            <div className="control required">
                <label>Category</label>
                <Select name="category" className="delay-log-control"
                    value={this.state.categoryId}
                    options={this.getCategoryOptions()}
                    onChange={this.handleCategoryChange}
                />
            </div>           
            <div className="control required">
                <label>Subcategory</label>
                <Select name="subcategory" className="delay-log-control"
                    value={this.state.subcategoryId}
                    options={this.getSubcategoryOptions(this.props.delaySubcategories.filter(s => s.categoryId === this.state.categoryId))}
                    onChange={this.handleSubcategoryChange}
                    disabled={this.state.disableSubcategory}
                />
            </div>
            <div className="control required">
                <label>Impacted Phase</label>
                <Select name="phaseOfOccurrence"
                    value={this.state.phaseOfOccurrenceId}
                    options={this.getPhaseOfOccurrenceOptions()}
                    onChange={this.handlePhaseOfOccurrenceChange}
                />
            </div>     
        </div>

        <div className="delay-log-details three-cols">
            <div className="control date-control">
                <label>Delay Start Date</label>
                <DateField className="delay-log-control"
                value={startDate} limits={{dateBelow: endDate}}
                onChange={this.handleDateChange('startDate')}
                />
            </div>       
            <div className="control date-control">
                <label>Delay End Date</label>
                <DateField className="delay-log-control"
                    value={endDate} limits={{dateAbove: startDate}}
                    onChange={this.handleDateChange('endDate')}
                />
                {delay ? <strong className="delay">{delay} Day Delay</strong> : null}
            </div>
        </div>

        <div className="control required">
          <label>Delay Description</label>
          <textarea name="cause" className="delay-log-control" value={this.state.cause} onChange={this.handleChange('cause')} />
        </div>

        <button className="btn-update" disabled={!canSubmit}>Update</button>
      </form>
    )
  }
}

DelayLogForm.propTypes = {
    log: PropTypes.object.isRequired,
    onSubmit: PropTypes.func.isRequired,
    projectId: PropTypes.string.isRequired,
    fetch_lkp_DelayAttributedTos: PropTypes.func.isRequired,
    fetch_lkp_DelayCategory: PropTypes.func.isRequired,
    fetch_lkp_DelaySubcategory: PropTypes.func.isRequired,
    fetch_lkp_DelaysGains: PropTypes.func.isRequired,
    fetch_lkp_DelayPhaseOfOccurrence: PropTypes.func.isRequired,
    delaysGains: PropTypes.array.isRequired,
    delayAttributedTos: PropTypes.array.isRequired,
    delayPhasesOfOccurence: PropTypes.array.isRequired,
    delayCategories: PropTypes.array.isRequired,
    delaySubcategories: PropTypes.array.isRequired
};

function mapStateToProps(state) {
    return {
        delaysGains: state.additionalProjectsStore.delaysGains,
        delayAttributedTos: state.additionalProjectsStore.delayAttributedTos,
        delayPhasesOfOccurence: state.additionalProjectsStore.delayPhasesOfOccurence,
        delayCategories: state.additionalProjectsStore.delayCategories,
        delaySubcategories: state.additionalProjectsStore.delaySubcategories
    };
}

export default connect(mapStateToProps, {fetch_lkp_DelayAttributedTos, fetch_lkp_DelayCategory, fetch_lkp_DelaySubcategory, fetch_lkp_DelaysGains, fetch_lkp_DelayPhaseOfOccurrence}) (DelayLogForm);
